import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from 'src/app/core/translate';

const AVAILABLE = 'AVAILABLE';
const DEACTIVATED = 'DEACTIVATED';

@Pipe({
    name: 'handleCardItemsListStatusDashboard'
})
export class HandleCardItemsListStatus implements PipeTransform {
    constructor(private readonly translateService: TranslateService) {}

    public transform(requestStatus: string): any {
        if (requestStatus) {
            return requestStatus == DEACTIVATED ? this.translateService.instant('notEnabled') : this.translateService.instant('enabled');
        }
    }
}
